
import { Card, CardItem, MatchCard, RouteCard, CustomCard } from '../Common/Card'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


import Search from '../Common/Search.vue'
import MatchEmpty from '../Common/MatchEmpty.vue'
import LoadingView from '../Common/LoadingView.vue'

import { mapActions, mapState } from 'vuex'


export default {
name: 'MatchSearch',
components: {
Card,
CardItem,
Tab,
TabItem,
MatchCard,
RouteCard,
CustomCard,
Search,
MatchEmpty,
XHeader,
LoadingView,
},
data: () => ({
searchText: '',
cityText: '',
type: 'match',
width: (window.innerWidth || document.body.clientWidth) - 125 - 20 - 8,
matchPlaceholder: '加载中...',
routePlaceholder: '加载中...',
customPlaceholder: '加载中...',
showLoading: false,
}),
computed: mapState({
matches: ({ search }) => search.matches,
routes: ({ search }) => search.routes,
customs: ({ search }) => search.customRoutes,
count: ({ search }) => ({
totalMatches: search.totalMatches,
totalRoutes: search.totalRoutes,
totalCustoms: search.totalCustomRoutes,
}),
}),
methods: {
...mapActions(['doSearch', 'showToast']),
switchType(type) {
this.type = type
},
searchMatch(text = '', city = '') {
this.searchText = text
this.cityText = city
this.matches.length = this.customs.length = 0
this.showLoading = true
return this.doSearch({ city: this.cityText, text: this.searchText })
.then((data) => {
this.showLoading = false
return data
})
},
},
created() {
document.title = '搜索结果'
const { q, city } = this.$route.query
this.searchText = q
this.cityText = city
this.searchMatch(q, city).then((data) => {
if (data.totalMatches === 0) {
this.matchPlaceholder = '没有赛事数据'
}
if (data.totalRoutes === 0) {
this.routePlaceholder = '没有线路数据'
}
if (data.totalCustomRoutes === 0) {
this.customPlaceholder = '没有定制线路数据'
}
if (data.totalMatches === 0) {

if (data.totalRoutes > 0) {
this.switchType('route')
} else if (data.totalCustomRoutes > 0) {
this.switchType('custom')
}
}
}).catch((err) => {
this.showToast({ content: err.body.resultInfo })
})
},
}



// WEBPACK FOOTER //
// ./client/components/Search/Search.vue